module.exports = "../study/imgs/maps/Nagano/GWQ8/Climate/HourlyPrecipitation50/Nagano_HourlyPrecipitation50_MRI_RCP85_End.png";